import React, { FormEvent, useEffect, useState } from 'react'

import { Modal, Row, Col } from 'react-bootstrap'
import { Button, FormText } from 'src/components'
import { haveAnyValue } from 'src/utils/utilitiesV2'
import { useDispatch } from 'react-redux'
import { showAlert } from 'src/actions/alert.actions'
import { handlerError } from 'src/selectors/error.selector'

interface ClientThresholdDetailProps {
  show: boolean
  threshold: IThreshold | undefined
  onHide: () => void
  onChange: (threshold: IThreshold) => void
}

export const ThresholdDetail = ({
  show,
  threshold,
  onHide,
  onChange,
}: ClientThresholdDetailProps) => {
  const dispatch = useDispatch()

  const [detail, setDetail] = useState<Partial<IThreshold>>({})

  useEffect(() => {
    if (!show) return
    setDetail(threshold ?? {})
  }, [show])

  const onClose = () => {
    onHide()
    setDetail({})
  }

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (
      !haveAnyValue(detail.min) ||
      !haveAnyValue(detail.max) ||
      !haveAnyValue(detail.rgb)
    ) {
      dispatch(showAlert(handlerError('Es necesario llenar todos los datos')))
    } else {
      onChange(detail as IThreshold)
      setDetail({})
    }
  }

  const onInputChange = event => {
    const { value, name, type } = event.target
    setDetail(prev => {
      return { ...prev, [name]: type === 'number' ? Number(value) : value }
    })
  }

  return (
    <Modal show={show} size={'sm'} centered onHide={onClose}>
      <Modal.Header>
        <Modal.Title>Detalle del rango</Modal.Title>
      </Modal.Header>
      <form onSubmit={onSubmit}>
        <Modal.Body>
          <Row>
            <Col xl={12}>
              <FormText
                label={'Cantidad minima'}
                value={detail.min}
                type={'number'}
                name={'min'}
                min={0}
                onChange={onInputChange}
                required
              />
            </Col>
            <Col xl={12}>
              <FormText
                label={'Cantidad máxima'}
                value={detail.max}
                type={'number'}
                name={'max'}
                min={detail.min}
                onChange={onInputChange}
                required
              />
            </Col>
            <Col xl={12}>
              <FormText
                label={'Color del umbral'}
                value={detail.rgb}
                type={'color'}
                name={'rgb'}
                onChange={onInputChange}
                required
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button type={'submit'}>Agregar</Button>
          </Row>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
